export default __webpack_public_path__ + "static/media/featuredCard.4fd34c50.png";